import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/dealer-users', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/dealer-users/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/dealer-users', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/dealer-users/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = (id, data) => {
  return httpClient
    .put(`/api/dealer-users/${id}/delete`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const resetpwd = data => {
  return httpClient
  .post('/api/dealer-user/reset-passwords', data)
  .then(response => Promise.resolve(response.data))
  .catch(error => Promise.reject(error.response.data))
  
}

export default { get, find, store, update, destroy, resetpwd }
